import { render, staticRenderFns } from "./DefaultMailTexts.vue?vue&type=template&id=506c5878&"
import script from "./DefaultMailTexts.vue?vue&type=script&lang=js&"
export * from "./DefaultMailTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports